import React from "react"
import PropTypes from "prop-types"
import AuthLogoLink from "components/Authentication/AuthLogoLink"
import TenantAuthLogo from "components/Authentication/TenantAuthLogo"
import { usePortalTenant } from "context/PortalTenantContext"
import { AUTH_BRAND } from "utils/authPlatform"

const AuthBrandingLogo = ({
  className = "login-platform-logo mb-4 mt-2",
}) => {
  const { isCustomLoginActive, tenantName, tenantBranding } = usePortalTenant()

  if (isCustomLoginActive) {
    return (
      <TenantAuthLogo
        logoUrl={tenantBranding?.logoUrl}
        alt={tenantName || AUTH_BRAND}
        className={className}
        fallbackToPlatform={false}
      />
    )
  }

  return <AuthLogoLink className={className} />
}

AuthBrandingLogo.propTypes = {
  className: PropTypes.string,
}

export default AuthBrandingLogo
